module.exports = __webpack_public_path__ + "static/slide-2-aa7bea9732a784c411dd60190e92bf8b.png";